import { Component, type ComponentType } from 'react';
import { connect } from 'react-redux';

import { CONNECTION_SAVE_DRAFT_ERROR } from 'src/app/shared/constants/errorMessages';
import ConnectionError from 'src/app/v1/views/components/ConnectionError';
import { EmailVerificationAlertMessage } from 'src/app/v1/views/components/EmailVerificationAlertMessage';
import { withDispatchDraft } from 'src/app/v1/views/enhancers/withDispatchDraft';
import { withNextPageRoute } from 'src/app/v1/views/enhancers/withNextPageRoute';
import type {
  AppState,
  Tealium,
  FormData,
  PageErrorMessageType,
} from 'src/types/appState';

interface Props {
  advertiserId: string;
  history: {
    goBack: () => void;
  };
  isEmailVerified?: boolean;
  tealium: Tealium;
  formData: FormData;
}

export const withDesktopEnhancers =
  (pageId: string) => (WrappedComponent: ComponentType<any>) => {
    class WithDesktopEnhancers extends Component<Props> {
      static displayName = `WithDesktopEnhancers_${
        WrappedComponent.displayName || WrappedComponent.name
      }`;
      state = {
        saveDraftFailed: false,
        emailVerificationFailed: false,
      };

      handleBackClick = () => {
        this.props.history.goBack();
      };

      handleSaveDraftFailed = () => {
        this.setState({
          saveDraftFailed: true,
        });
      };

      handleEmailVerificationFailed = () => {
        this.setState({
          emailVerificationFailed: true,
        });
      };

      renderPageErrorMessage = (): PageErrorMessageType => {
        if (this.state.emailVerificationFailed) {
          return <EmailVerificationAlertMessage />;
        }
        if (this.state.saveDraftFailed) {
          return <ConnectionError errorType={CONNECTION_SAVE_DRAFT_ERROR} />;
        }
        return null;
      };

      render() {
        const componentProps = {
          ...this.props,
          pageId,
          handleBackClick: this.handleBackClick,
          handleEmailVerificationFailed: this.handleEmailVerificationFailed,
          handleSaveDraftFailed: this.handleSaveDraftFailed,
          pageErrorMessage: this.renderPageErrorMessage(),
        };

        return <WrappedComponent {...componentProps} />;
      }
    }

    const mapStateToProps = (state: AppState) => ({
      advertiserId: state.session.advertiserId,
      isEmailVerified: state.session?.isEmailVerified,
      formData: state.formData,
      tealium: state.tealium,
    });

    return withNextPageRoute(
      withDispatchDraft(connect(mapStateToProps)(WithDesktopEnhancers)),
    );
  };
